module.exports = __webpack_public_path__ + "static/media/ZWZ Metallurgy bearing Catalogue.b9ddae45.pdf";